import graphql__c2882979543ba642af4d from "./__generated__/SetUpStripePaymentMethodDialogCreateSetupIntentMutation.graphql.ts";import * as React from "react";
import {useContext, useState} from "react";
import {useIntl} from "react-intl";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useRelayEnvironment} from "react-relay/hooks";
import {Elements, PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import CabanaConfigurationContext from "../../configuration/CabanaConfigurationContext";
import {loadStripe} from "@stripe/stripe-js";
import {commitMutation, graphql} from "react-relay";
import {SetUpStripePaymentMethodDialogCreateSetupIntentMutation} from "./__generated__/SetUpStripePaymentMethodDialogCreateSetupIntentMutation.graphql";
import {useNavigate} from "react-router-dom";
import {faSpinnerThird} from "@fortawesome/pro-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type SetUpStripePaymentMethodDialogProps = {
    customerAccountIdentifier: string
    handleCloseDialog: () => {}
}

const SetUpStripePaymentMethodForm: React.FC<SetUpStripePaymentMethodDialogProps> = (props) => {
    const intl = useIntl();
    const {customerAccountIdentifier, handleCloseDialog} = props;
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();

    const handleSubmission = async (input) => {
        if (!stripe || !elements) {
            return;
        }
        const result = await stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: window.location.href
            },
            redirect: 'if_required'
        });

        if (result.error) {
            // Show error to your customer (e.g., payment details incomplete)
            console.log('stripe.confirmPayment', result.error.message);
        } else {
            handleCloseDialog();
            navigate('/customers/' + customerAccountIdentifier + '/payment')
        }
    }

    const initialValues = {}
    return (
        <FormDialog handleCloseDialog={handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} headline={intl.formatMessage({id: 'dialog.SetUpStripePaymentMethodDialog.headline'})} submitLabel={intl.formatMessage({id: 'button.submit'})}>
            <Section>
                <Row>
                    <div className="min-h-96">
                        <PaymentElement/>
                    </div>
                </Row>
            </Section>
        </FormDialog>
    )
}

const SetUpStripePaymentMethodDialog: React.FC<SetUpStripePaymentMethodDialogProps> = (props) => {
    const intl = useIntl();
    const {customerAccountIdentifier, handleCloseDialog} = props;
    const relayEnvironment = useRelayEnvironment();
    const cabanaConfiguration = useContext(CabanaConfigurationContext);
    const {addError} = useErrorContext();

    const [paymentMethodSetupIntent, setPaymentMethodSetupIntent] = useState({id: '', clientSecret: ''});

    if (paymentMethodSetupIntent.id === '') {
        commitMutationWithErrorHandling<SetUpStripePaymentMethodDialogCreateSetupIntentMutation>(
            relayEnvironment,
            {
                mutation: graphql__c2882979543ba642af4d,
                variables: {
                    input: {
                        customerAccountIdentifier: customerAccountIdentifier
                    }
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    } else {
                        setPaymentMethodSetupIntent(response.createPaymentMethodSetupIntent);
                    }
                },
                onError: (error) => {
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToSetUpStripePayment'})
            }
        );
    }

    const stripe = loadStripe(cabanaConfiguration.stripe.publishableKey);
    const stripeElementsOptions = {
        clientSecret: paymentMethodSetupIntent.clientSecret
    }

    if (paymentMethodSetupIntent.clientSecret === '') {
        return (
            <FormDialog handleCloseDialog={handleCloseDialog} handleSubmission={() => {
            }} initialValues={{}} headline={intl.formatMessage({id: 'dialog.SetUpStripePaymentMethodDialog.headline'})} submitLabel={intl.formatMessage({id: 'button.submit'})}>
                <Section>
                    <Row>
                        <div className='min-h-96 text-center align-middle'>
                            <FontAwesomeIcon icon={faSpinnerThird} spin className="h-10 w-10 mt-40"/>
                        </div>
                    </Row>
                </Section>
            </FormDialog>
        );
    }

    return (
        <Elements stripe={stripe} options={stripeElementsOptions}>
            <SetUpStripePaymentMethodForm customerAccountIdentifier={customerAccountIdentifier} handleCloseDialog={handleCloseDialog}/>
        </Elements>
    )
}

export default SetUpStripePaymentMethodDialog;
